<template>
  <b-container v-if="processdate(LOI.LOIDate) < processdate('01/01/2025')">
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
            >
              <img style="width:140px;margin-top:10px;"  src="@/assets/images/header4.png" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                <span
                  style="font-size:17.0pt;font-weight:bold;"
                  v-if="LOI.Division!='Konkan'"
                >ब्रम्‍हलिन आचार्य दिव्‍यानंद महाराज आर्थिक विकास महामंडळ</span>

                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >जुहू सुप्रिम शॉपिंग सेंटर, गुलमोहर क्रॉस रोड नं.९, विलेपार्ले (पश्चिम), मुंबई- ४०० ०४९.</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी क्र.</span>
              <span style="font-size:11.0pt;font-weight:normal;"> ०२२ - २६२०२५८६.</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">https://www.vnvjntdc.org/</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span>vnvjntdcproject@gmail.com
              </span>
            </td>
          </tr>
        </table>
        <span style="font-size:8pt;float:right"  v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN-U65990MH1984SGC032054</span>
        <span style="font-size:8pt;float:right" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN-U65990MH1984SGC032054</span>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==1 || Loantype== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==2 || Loantype=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==3 || Loantype== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (Loantype==1 || Loantype==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="Loantype==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (Loantype==1 || Loantype==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.ApplicantName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==1 || Loantype==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपणास कळविण्यात येते की महामंडळाच्या
              <span v-if="Loantype==2 || Loantype=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="Loantype==1 || Loantype=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="Loantype==3 || Loantype=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==1 || Loantype=='1'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, आपण निवडत असलेल्या या {{LOI.BusinessName}} उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणास हे प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे;
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==2 || Loantype=='2'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, आपण निवडत असलेल्या या {{LOI.BusinessName}} उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणास हे प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे;
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==3 || Loantype=='3'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, {{LOI.BusinessName}} या अभ्यासक्रमासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी, आपणास हे हेतु प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="display: block; margin-left:50%;text-align:center; align-items:right">
            <span style="font-weight:bold;font-size:12.0pt">Sd/-</span>


            <br />
            <span style="font-size:12.0pt;">महाव्यवस्थापक</span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >ब्रम्‍हलिन आचार्य दिव्‍यानंद महाराज आर्थिक विकास महामंडळ</span>
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span>
            <br />
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==1 || Loantype=='1'">
            <p
              style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
            >महामंडळाच्या अटी व शर्ती</p>
            <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==2 || Loantype=='2'">
           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==3 || Loantype=='3'">
            <p
              style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
            >महामंडळाच्या अटी व शर्ती</p>

           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
            <span style="font-weight:bold;font-size:12pt">Sd/-</span>
            <br />
            <span style="font-size:12.0pt">महाव्यवस्थापक </span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >वसंतराव नाईक विमुक्त जाती व भटक्या जमाती विकास महामंडळ मर्यादित</span>
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

  <b-container v-else-if="processdate(LOI.LOIDate) >= processdate('01/01/2025') && processdate(LOI.LOIDate) < processdate('21/04/2025')">
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
            >
              <img style="width:140px;margin-top:10px;" src="@/assets/images/header4.png"  />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                <span
                  style="font-size:17.0pt;font-weight:bold;"
                  v-if="LOI.Division!='Konkan'"
                >ब्रम्‍हलिन आचार्य दिव्‍यानंद महाराज आर्थिक विकास महामंडळ</span>

                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >जुहू सुप्रिम शॉपिंग सेंटर, गुलमोहर क्रॉस रोड नं.९, विलेपार्ले (पश्चिम), मुंबई- ४०० ०४९.</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
              <span style="font-size:11.0pt;font-weight:normal;"> ०२२ - २६२०२५८६.</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">https://www.vnvjntdc.org/</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span> vnvjntdcproject@gmail.com <br/>
                 <span style="font-size:8pt;float:right"  v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN-U65990MH1984SGC032054</span>
        <span style="font-size:8pt;float:right" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN-U65990MH1984SGC032054</span>
              </span>
            </td>
          </tr>
        </table>

          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==1 || Loantype== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==2 || Loantype=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==3 || Loantype== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (Loantype==1 || Loantype==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="Loantype==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (Loantype==1 || Loantype==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.ApplicantName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==1 || Loantype==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपण, महामंडळाच्या
              <span v-if="Loantype==2 || Loantype=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="Loantype==1 || Loantype=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="Loantype==3 || Loantype=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==1 || Loantype=='1'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==2 || Loantype=='2'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==3 || Loantype=='3'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या  {{LOI.BusinessName}} या अभ्यासक्रमासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==1 || Loantype=='1'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==2 || Loantype=='2'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==3 || Loantype=='3'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
          <!-- <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/> -->
            <span style="font-weight:bold;font-size:12pt">Sd/-</span>
            <br />
            <span style="font-size:12.0pt">{{ this.loidesignationlabel }}</span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >ब्रम्‍हलिन आचार्य दिव्‍यानंद महाराज आर्थिक विकास महामंडळ</span>
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

  <b-container v-else>
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
            >
              <img style="width:140px;margin-top:10px;" src="/static/header4.ico" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                <span
                  style="font-size:17.0pt;font-weight:bold;"
                  v-if="LOI.Division!='Konkan'"
                >ब्रम्‍हलिन आचार्य दिव्‍यानंद महाराज आर्थिक विकास महामंडळ</span>

                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >जुहू सुप्रिम शॉपिंग सेंटर, गुलमोहर क्रॉस रोड नं.९, विलेपार्ले (पश्चिम), मुंबई- ४०० ०४९.</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
              <span style="font-size:11.0pt;font-weight:normal;"> ०२२ - २६२०२५८६.</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">https://www.vnvjntdc.org/</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span> vnvjntdcproject@gmail.com <br/>
                  <span style="font-size:8pt;float:right"  v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN-U65990MH1984SGC032054</span>
        <span style="font-size:8pt;float:right" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN-U65990MH1984SGC032054</span>
              </span>
            </td>
          </tr>
        </table>

          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==1 || Loantype== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==2 || Loantype=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==3 || Loantype== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (Loantype==1 || Loantype==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="Loantype==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (Loantype==1 || Loantype==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.ApplicantName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==1 || Loantype==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपण, महामंडळाच्या
              <span v-if="Loantype==2 || Loantype=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="Loantype==1 || Loantype=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="Loantype==3 || Loantype=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==1 || Loantype=='1'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==2 || Loantype=='2'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==3 || Loantype=='3'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या  {{LOI.BusinessName}} या अभ्यासक्रमासाठी, रु. {{LOI.LoanAmount || LOI.SanctionAmount || LOI.ApprovedLOIAmount || LOI.Amount}} कर्ज रक्कमेसाठी,
              आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==1 || Loantype=='1'">


          <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==2 || Loantype=='2'">


         <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==3 || Loantype=='3'">


           <p style="margin-bottom: 2px; font-size:12.0pt;">
    १. सदर सशर्त हेतू पत्र (Letter of Intent) संगणक प्रणालीद्वारे निर्गमित झाल्यापासून
    {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सशर्त हेतू पत्राची मुदत संपुष्टात आल्यानंतर,
    अर्जकर्ता / गट संस्था यांच्या इच्छेनुसार ३० दिवसांच्या आतमध्ये महामंडळाच्या वेबपोर्टलवर
    ऑनलाईन सशर्त हेतू पत्र (LOI) नूतनीकरणासाठी अर्ज दाखल करू शकतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    २. अर्जात नमूद केलेली माहिती जाणूनबुजून लपविण्याचा प्रयत्न केल्यास तसेच ती खोटी आढळल्यास,
    महामंडळ संबंधित कर्ज सवलत रद्द करून देण्यात आलेली रक्कम एकरकमी वसूल करील. या संदर्भातील
    सर्व हक्क महामंडळाकडे राहतील.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका तसेच भारतीय रिझर्व्ह बँकेची
    मान्यता प्राप्त आणि महाराष्ट्र राज्याच्या कार्यक्षेत्रात येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी
    सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ. बँकांमध्ये अर्जदाराने LOI / पात्रता प्रमाणपत्राद्वारे
    कर्ज मागणी करावी.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ४. अनियमित लाभार्थी किंवा थकीत हप्त्यांपैकी भरणा केलेल्या थकीत रकमेपैकी फक्त नियमित
    होणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ५. सशर्त हेतू पत्र (Letter of Intent) निर्गमित झाल्यानंतरचेच बँकेचे कर्ज मंजुरी आदेश अर्जदाराने
    वेबपोर्टलवर अपलोड करणे आवश्यक आहे. जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत,
    अथवा हेतू पत्राच्या दिनांकापूर्वीचे कर्ज मंजुरी आदेश अपलोड केल्यास संबंधित अर्जदार योजना पात्र
    ठरणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ६. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या वेळापत्रकानुसार (मुद्दल व व्याज)
    केल्यानंतरच अर्जदार व्याज परताव्यास पात्र ठरेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ७. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही कोणत्याही कारणासाठी
    महामंडळाविरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ८. बँकेने अर्जदारास वितरित केलेल्या कर्ज रकमेवरील व्याजाची नियमित परतफेड केलेल्या
    अर्जदारास बँकेच्या मंजुरी पत्रानुसार कमाल १२% मर्यादेत असलेली व्याज रक्कमच महामंडळाकडून
    व्याज परतावा म्हणून अदा करण्यात येईल. बँकेकडे कर्ज व्याज स्वरूपात भरणा केलेली रक्कम वगळता
    दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा महामंडळ
    अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ९. व्याज परतावा मागणी ही देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल. त्यानंतर आलेले
    मागणी अर्ज स्वीकारले जाणार नाहीत.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    १०. अर्जासंबंधी आकारण्यात येणारे शुल्क, त्यातील घट किंवा वाढ करण्याचे सर्व हक्क महामंडळाकडे
    राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केला जाणार नाही.
  </p>

  <p style="margin-bottom: 2px; font-size:12.0pt;">
    ११. वर नमूद केलेल्या अटी व शर्तींमध्ये आवश्यकतेनुसार सुधारणा, फेरबदल किंवा दुरुस्ती करण्याचे
    सर्व हक्क महामंडळाने राखून ठेवले आहेत.
  </p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
          <!-- <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/> -->
            <!-- <span style="font-weight:bold;font-size:12pt">Sd/-</span> -->
            <br>
            <span style="font-size:12.0pt" v-if="shouldShowAnandLomteName">Sd/-</span>
            <br v-if="shouldShowAnandLomteName" />
            <span style="font-size:12.0pt">महाव्यवस्थापक </span>
            <br />
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >ब्रम्‍हलिन आचार्य दिव्‍यानंद महाराज आर्थिक विकास महामंडळ</span>
            <span
              style="font-size:12.0pt;" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'"
            >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";

export default {
  props: ["ApplicationID", "Loantype", "UserID", "PastLOI"],
  data() {
    return {
      LOI: {
        LoanApplicationNo: "",
        ApplicationDate: "",
        ApplicantName: "",
        AdharNo: "",
        Address: "",
        LOIDate: "",
        LOINumber: "",
        BusinessName: "",
        Division: "",
        LOIValidTill: "",
        IsExtended: false,
        LoanAmount: 0
      },
      isLoading: false,
      alertText: "",
      showDismissibleAlert: true,
      variant: "danger",
      qrtext: "this is error",
      size: 100,
      loidesignationlabel: ""
    };
  },
  computed: {
    shouldShowAnandLomteName() {
      const currentDate = new Date();
      const cutoffDate = new Date('2025-09-05'); // September 5, 2025
      return currentDate >= cutoffDate;
    }
  },
  methods: {
    print() {
      this.$htmlToPaper("printLOI");
    },
    getImgUrl(pic) {
      if (pic) {
        return `https://aws.msobcfdc.in/S3BucketApril/${this.UserID}/${pic}`;
      }
    },
    processdate(date) {
      const parts = date.includes("/") ? date.split("/") : date.split("-");
      const formattedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      return formattedDate.getTime();
    }
  },
  mounted() {
    let promiseU = this.PastLOI ? apis.ReadPastLOI(this.ApplicationID) : apis.ReadLOI(this.ApplicationID);

    promiseU
      .then(response => {
        if (response.status === 200) {
          this.LOI = JSON.parse(response.body);
          console.log('LOI Data:', this.LOI);
          // Use the correct portal URL
          const baseUrl = 'https://portal.vnvjntdc.org';
          this.qrtext = `${baseUrl}/verifyloi/${this.ApplicationID}/${this.LOI.LOINumber}`;
          this.isLoading = false;

          const loiDate = this.processdate(this.LOI.LOIDate);
          const cutoffDate = this.processdate('01/01/2025');

          this.loidesignationlabel = loiDate < cutoffDate ? "महाव्यवस्थापक" : "व्यवस्थापकीय संचालक";
        } else {
          this.alertText = response.body;
          this.isLoading = false;
          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
        this.isLoading = false;
      });
  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}

.print-button-wrap button {
  color: #fff;
  background-color: #0A0032;
  font-size: 13px;
  font-weight: bold;
  border: none;
  padding: 8px 20px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
}

.print-button-wrap {
  margin: auto;
  width: fit-content;
  margin-top: 20px;
  margin-bottom: 30px;
}

.loi {
  margin-bottom: 50px;
  margin-top: 20px;
}

.loi,
.loi p {
  color: #000;
  font-size: 16px;
  font-family: "Laila", serif;
}

.tobold {
  font-weight: bold;
}

.loi h2 {
  font-size: 29px;
  text-align: center;
}

.loi h3 {
  font-size: 22px;
  text-align: center;
  margin-top: 7px;
  margin-bottom: 20px;
}

.loi .num-date {
  margin-top: 35px;
}

.loi .app-nm {
  display: inline-block;
  margin-right: 80px;
}

.loi .prati span {
  display: block;
}

.loi .prati {
  margin-top: 20px;
  margin-bottom: 20px;
}

.loi .priy {
  margin-top: 20px;
  margin-bottom: 25px;
}

.loi .vyav-s span {
  display: block;
  font-weight: bold;
}

.loi .ati {
  margin-top: 25px;
  margin-bottom: 25px;
}

.loi .ati h4 {
  font-size: 19px;
  font-weight: bold;
  margin-bottom: 17px;
}

.loi .ati p {
  margin-bottom: 13px;
}

.loi {
  width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 1199px) {
  .loi {
    width: 80%;
  }
}

@media (max-width: 767px) {
  .loi {
    width: 90%;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 15px;
  }

  .loi h2 {
    font-size: 24px;
  }

  .loi h3 {
    font-size: 20px;
  }

  .loi .ati h4 {
    font-size: 18px;
  }

  .loi .app-nm {
    margin-right: 0;
    display: block;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/RegistrationLoan/LoanLOIPrint.vue